// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "pbrBlockImageProcessing";
const shader = `#if defined(IMAGEPROCESSINGPOSTPROCESS) || defined(SS_SCATTERING)
#if !defined(SKIPFINALCOLORCLAMP)
finalColor.rgb=clamp(finalColor.rgb,0.,30.0);#endif
#else
finalColor=applyImageProcessing(finalColor);#endif
finalColor.a*=visibility;#ifdef PREMULTIPLYALPHA
finalColor.rgb*=finalColor.a;#endif
`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @hidden */
export const pbrBlockImageProcessing = { name, shader };
